<template>
  <ripristinable-dialog v-model="isActive" @confirm="onConfirm" :title="$t('convenzioni.messaggi.eliminato')">
    <v-flex xs12>
      <span class="mr-2">{{ $t('label.nome') }}: </span>
      <b>{{ convenzione.nome }}</b>
    </v-flex>

    <v-flex xs12>
      <span class="mr-2">{{ $t('label.telefono') }}: </span>
      <b>{{ $utils.formatPhone(convenzione.telefono) }}</b>
    </v-flex>
  </ripristinable-dialog>
</template>

<script>
import Toggleable from '@/mixins/toggleable'
import RipristinableDialog from '@/components/base/RipristinableDialog'

export default {
    name: 'ConvenzioneDeletedDialog',
    mixins: [Toggleable],
    components: { RipristinableDialog },
    data: () => ({
        convenzione: {}
    }),
    methods: {
        show (convenzione) {
            this.convenzione = convenzione
            this.isActive = true
        },
        onConfirm () {
            let vue = this
            this.$confirmDialog.show(
                this.convenzione.nome,
                this.$t('convenzioni.messaggi.conferma_ripristino'),
                function (nome) {
                    this.$api.convenzioni.restore(nome)
                        .then(() => {
                            vue.$snackbar.show(this.$t('convenzioni.messaggi.ripristinato'), 'success')
                            vue.$emit('success')
                            vue.isActive = false
                        }).catch(e => {
                            if (e.response.status === 304) {
                                vue.$snackbar.show(this.$t('convenzioni.errori.errore_ripristino'), 'error')
                            } else {
                                vue.$snackbar.showServerError(e)
                            }
                        })
                })
        }
    }
}
</script>
